import { UserInfo } from '@/apis/account/types';
import { defineStore } from 'pinia';
import { ref } from 'vue';

const useAccountStore = defineStore('account', () => {
  // ==================================================
  // state
  // ==================================================
  // accessToken
  const accessToken = ref<string | null>(null);
  // userInfo
  const userInfo = ref<UserInfo | null>(null);

  // ==================================================
  // actions
  // ==================================================
  // 重置全部 state
  const resetState = () => {
    accessToken.value = null;
    userInfo.value = null;
  };
  const updateAccessToken = (accessToken_: typeof accessToken.value) => {
    accessToken.value = accessToken_;
  };
  const updateUserInfo = (userInfo_: typeof userInfo.value) => {
    userInfo.value = userInfo_;
  };

  return {
    accessToken,
    userInfo,
    resetState,
    updateAccessToken,
    updateUserInfo,
  };
});

export { useAccountStore };
